




























































































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VendorDetail, Vendor, OcrMappingDataViewModel } from '@/models/accounting/vendor';
import common from '@/services/common';
import { FileHelper } from '@/helper/file.helper';
import VueUploadComponent from 'vue-upload-component';
import { Base } from '@/components/common/base';
import { vendorService } from '@/shared';
import { FileSize } from '@/helper/enum';
import { IFileUploaderOption } from '@/models/fileUploader';
import { FileUploadDataViewModel } from '@/Alynk.dtos';

@Component({
    props: ['methodName', 'progress'],
    computed: {
        methodtoCall: {
            get() {
                return this.$props.methodName;
            },
        },
    },
    components: {
        FileUpload: () => import('@/components/common//app.fileupload.v2.vue'),
        Grid: () => import('@/components/common/app.grid.vue'),
        AppDialog: () => import('@/components/common/app.dialog.vue'),
    },
})
export default class VendorDetailPage extends Base {
    public vendorNumber: string = '';
    public selectedFiles: any = [];
    public dragclass: string = '';
    public files: any = [];
    public dragging: boolean = false;
    public attachmentsList: any = [];
    public vendorDetail: VendorDetail = {
        vendorNumber: '',
    };
    public chargeAccounts: any[] = [];
    public loading: boolean = false;
    public requestProgress: boolean = false;
    public vendorLoading: boolean = false;
    public disableSaveButton: boolean = false;
    public accountLoading: boolean = false;
    public ocrMapping: OcrMappingDataViewModel = {
        vendorName: '',
        address: '',
        invoiceDate: '',
        invoiceNumber: '',
        description: '',
        item: '',
        amount: '',
        tax: '',
        total: '',
    };
    public vendor: Vendor = {
        vendorName: '',
        addressLine1: '',
        city: '',
        phone: '',
        state: '',
        vendorNumber: '',
        zip: '',
        attachments: [],
        glCompanyName: '',
        updatedType: 'Settings',
        ocrMapping: this.ocrMapping,
    };
    public constants = {
        tenantId: 0,
        enterpriseId: 0,
        glCompanyName: '',
    };

    public beforeDestroy() {
        const buttons = [];
        this.$emit('updateToolBar', buttons);
    }
    public callMethod(methodName): void {
        if (methodName === 'backToVendorsList') {
            // this.$router.push({ name: 'vendors.list' });
            if (history.state && history.length > 1) {
                this.$router.back();
            } else {
                this.$router.push({ name: 'vendors.list' });
            }
        } else if (methodName === 'save') {
            this.saveVendorDetails();
        }
        this.resetMethodName(methodName);
    }
    public resetMethodName(methodName): void {
        if (methodName !== '') {
            this.$emit('resetMethodName', methodName);
        }
    }
    public fileUploderRef: string = "vendorDetail";
    public uploadBtnLoading: boolean = false;

    public fileDialog: IFileUploaderOption = {
        ref: this.fileUploderRef,
        inputFiles: this.files,
        multiple: true,
        drop: true,
        extensions:['.ani', '.bmp', '.cal', '.fax', '.gif', '.img', '.jbg', '.jpe', '.jpeg', '.jpg', '.mac', '.pbm', '.pcd', '.pcx', '.pct', '.pgm', '.png', '.ppm', '.psd', '.ras', '.tga', '.tif', '.tiff', '.wmf', '.pdf', '.doc', '.docx', '.txt', '.xls', '.xlsx']
    };
    public syncAttachmentFiles(inputFilesToSync: any[], outputFilesToSync: FileUploadDataViewModel[]) {
        this.files = inputFilesToSync;
        let attachments = [];

        outputFilesToSync.forEach((file) => {
            attachments.push({
                base64: file.base64,
                extension: file.extension,
                fileSize: file.fileSize,
                filename: file.fileName
            });

        });
        this.vendor.attachments = attachments;
    }

    public fileUploadLoader(val: boolean) {
        this.uploadBtnLoading = val;
    }
    public updateToolBar(): void {
        const buttons: any = [];
        buttons.push({ id: '0', type: 'button', title: this.$t('vendorDetailPage.titleBackToVendorsList'), disabled: false, visible: true, class: 'btn', label: this.$t('vendorDetailPage.labelBack'), click: 'backToVendorsList', icon: 'fas fa-arrow-left', requestProgress: true });
        this.$emit('updateToolBar', buttons);
    }
    public mounted() {
        // activating tab
        this.$root.$emit('sidebar.layout.vue', 'vendorList');

        // Toolbar
        this.updateToolBar();
        this.$watch('methodtoCall', (newVal, oldVal) => {
            if (newVal) {
                this.callMethod(newVal);
            }
        });

        this.vendorNumber = this.$route.params.vendorNumber;
        this.getVendorDetail();
        this.getChargeAccounts();
    }
    public async validateAutoPay(): Promise<void> {
        //window.setInterval(() => {
        // if (this.vendorDetail.allowAutoPay) {
        //     this.vendorDetail.allowAutoApproval = true;
        // }
        //}, 1000);
    }
    public async validateAutoApproval(): Promise<void> {
        // window.setInterval(() => {
        // if (!this.vendorDetail.allowAutoApproval) {
        //     this.vendorDetail.allowAutoPay = false;
        // }
        // }, 1000);
    }

    public async saveVendorDetails(): Promise<void> {
        if (!await this.validateForm()) {
            return;
        }
        this.requestProgress = true;
        this.disableSaveButton = true;
        this.$emit('update:progress', this.requestProgress);

        this.vendor.id = this.vendorDetail.id;
        this.vendor.vendorName = this.vendorDetail.vendorName;
        this.vendor.city = this.vendorDetail.billCity;
        this.vendor.state = this.vendorDetail.billStateCode;
        this.vendor.glCompanyId = this.vendorDetail.glCompanyId;
        this.vendor.companyNo = this.vendorDetail.companyNo;
        this.vendor.zip = this.vendorDetail.zip;
        this.vendor.federalTaxId = this.vendorDetail.federalTaxId;
        this.vendor.vendorType = this.vendorDetail.vendorType;
        this.vendor.vendorNumber = this.vendorDetail.vendorNumber;
        this.vendor.addressLine1 = this.vendorDetail.billAddressLine1;
        this.vendor.monthlyAutoApprovalLimit = this.vendorDetail.monthlyAutoApprovalLimit;
        this.vendor.monthlyApprovedAmount = this.vendorDetail.monthlyApprovedAmount;
        this.vendor.allowAutoApproval = this.vendorDetail.allowAutoApproval;
        this.vendor.allowAutoPay = this.vendorDetail.allowAutoPay;
        this.vendor.accountNumber = this.vendorDetail.accountNumber;
        this.vendor.description = this.vendorDetail.description;
        try {
            await vendorService.saveVendorAsync(this.vendor);
            this.showAlert(true, this.$t('vendorDetailPage.alertVendorSavedSuccessfully'));
            this.$root.$emit('resetFileList', this.fileUploderRef);

            this.$router.push({
                name: 'vendors.list',
            });

        } finally {
            this.disableSaveButton = false;
            this.requestProgress = false;
            this.$emit('update:progress', this.requestProgress);
        }
    }

    public async getVendorDetail(): Promise<void> {
        try {
            this.loading = true;
            const resp = await vendorService.getVendorDetailAsync(this.vendorNumber);
            if (resp) {
                this.vendorDetail = resp;
                this.vendorDetail.lastStatementDate = this.$moment(this.vendorDetail.lastStatementDate)
                    .format('MM/DD/YYYY');
                this.vendorDetail.lastPaymentDate = this.$moment(this.vendorDetail.lastPaymentDate)
                    .format('MM/DD/YYYY');
                if (!this.vendorDetail) {
                    this.showAlert(false, this.$t('vendorDetailPage.alertSomeErrorOccurred'));
                }
            }
        } finally {
            this.loading = false;
        }
    }

    public async getChargeAccounts(): Promise<void> {
        this.setError('Account Number', this.$t('vendorDetailPage.loadingAccounts') as string);
        try {
            this.accountLoading = true;
            const chargeAccounts = await vendorService.getStoreChargeAllAccountsAsync();
            this.removeError('Account Number');
            this.chargeAccounts = chargeAccounts.results;
        } catch (e) {
            this.setError('Account Number', this.$t('vendorDetailPage.accountsNotFound') as string);
            this.chargeAccounts = [];
        } finally {
            this.accountLoading = false;
        }
    }

    public setError(fieldName, errorMsg) {
        this.$validator.errors.add({ field: fieldName, msg: errorMsg });
    }

    public removeError(fieldName) {
        this.$validator.errors.remove(fieldName);
    }
}
